/* =========================================================
   Page hook: add a reliable class for Luminara product page
   Robust: waits for <body>, handles SPA/editor swaps
   ========================================================= */
(function () {
  const PATH_RE = /^\/products\/luminara(\/|$)/i;
  let started = false;

  function apply() {
    if (!document.body) return;
    const isLum = PATH_RE.test(window.location.pathname || "");
    document.body.classList.toggle("trab-product-luminara", isLum);
  }

  function start() {
    if (started) return;
    started = true;

    apply();
    document.addEventListener("shopify:section:load", apply);
    window.addEventListener("popstate", apply);
    window.addEventListener("hashchange", apply);

    // Keep it sticky for editor + SPA transitions
    setInterval(apply, 800);
  }

  // If body isn't ready yet, retry a few times quickly
  let tries = 0;
  const t = setInterval(() => {
    tries++;
    if (document.body) {
      clearInterval(t);
      start();
    }
    if (tries > 50) clearInterval(t); // safety stop (~5s)
  }, 100);

  document.addEventListener("DOMContentLoaded", start);
})();

/**
 * Prestige v7+ upgrade-safe customizations
 * - Keep this file small-ish and modular.
 * - Prefer listening to theme events + extending exported web components.
 */

// Example: listen for theme events (document-level)
document.addEventListener('variant:change', (event) => {
  const { variant, previousVariant } = event.detail;
  const form = event.target;

  // Your logic here (example: console log)
  // console.log('Variant changed', { variant, previousVariant, form });
});

// Cart events
document.addEventListener('variant:add', (event) => {
  const { items, cart } = event.detail;
  // console.log('Variant added', { items, cart });
});

document.addEventListener('line-item:change', (event) => {
  const { quantity, cart } = event.detail;
  // console.log('Line item changed', { quantity, cart });
});

document.addEventListener('cart:change', (event) => {
  const { cart, baseEvent } = event.detail;
  // console.log('Cart changed', { baseEvent, cart });
});

document.addEventListener('cart:error', (event) => {
  const { error } = event.detail;
  // console.warn('Cart error', error);
});

// If you need to force UI refresh (cart count/drawer, etc.)
// document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));

/* =========================================================
   Prestige – Auto-rotate Text with Icons (mobile only)
   Section: template--21186768961772__text_with_icons_PhMhKW
   Works with Prestige web component + fallback scroll-snap
   ========================================================= */

(function () {
  const SECTION_ID = "shopify-section-template--21186768961772__text_with_icons_PhMhKW";
  const MOBILE_MQ = window.matchMedia("(max-width: 749px)");
  const REDUCE_MOTION = window.matchMedia("(prefers-reduced-motion: reduce)");
  const INTERVAL_MS = 4200;

  let timer = null;
  let pauseUntil = 0;
  let io = null;

  function isMobile() {
    return MOBILE_MQ.matches;
  }

  function stop() {
    if (timer) clearInterval(timer);
    timer = null;
    pauseUntil = 0;
    if (io) io.disconnect();
    io = null;
  }

  function pause(ms = 2000) {
    pauseUntil = Date.now() + ms;
  }

  function getSection() {
    return document.getElementById(SECTION_ID);
  }

  function getCarousel(section) {
    return section?.querySelector("text-with-icons-carousel") || null;
  }

  function getItems(carousel) {
    return carousel ? Array.from(carousel.querySelectorAll(".text-with-icons__item")) : [];
  }

  function getSelectedIndex(items) {
    const i = items.findIndex((el) => el.classList.contains("is-selected"));
    return i >= 0 ? i : 0;
  }

  function tryNativeNext(carousel) {
    // Try common Prestige/web-component style APIs
    if (!carousel) return false;

    const candidates = ["next", "goToNext", "slideNext", "selectNext", "scrollNext"];
    for (const name of candidates) {
      if (typeof carousel[name] === "function") {
        carousel[name]();
        return true;
      }
    }

    // Sometimes there is a nested controller
    const ctrl = carousel.carousel || carousel.slider || carousel._carousel;
    if (ctrl) {
      for (const name of candidates) {
        if (typeof ctrl[name] === "function") {
          ctrl[name]();
          return true;
        }
      }
    }

    return false;
  }

  function fallbackScroll(carousel) {
    const items = getItems(carousel);
    if (items.length < 2) return;

    const current = getSelectedIndex(items);
    const next = (current + 1) % items.length;

    // Prefer scrolling the actual next item into view
    items[next].scrollIntoView({
      behavior: "smooth",
      inline: "center",
      block: "nearest",
    });
  }

  function attachPauseListeners(section, carousel) {
    const onUser = () => pause(2400);

    section.addEventListener("touchstart", onUser, { passive: true });
    section.addEventListener("touchmove", onUser, { passive: true });
    section.addEventListener("pointerdown", onUser, { passive: true });
    section.addEventListener("wheel", onUser, { passive: true });

    // If the carousel itself scrolls, pause on scroll too
    carousel.addEventListener("scroll", onUser, { passive: true });
  }

  function start() {
    stop();

    if (!isMobile() || REDUCE_MOTION.matches) return;

    const section = getSection();
    if (!section) return;

    // Prestige sometimes hydrates web components after DOM load, so retry briefly
    let tries = 0;
    const maxTries = 25;

    const init = () => {
      if (!isMobile() || REDUCE_MOTION.matches) return;

      const carousel = getCarousel(section);
      if (!carousel) {
        if (++tries < maxTries) return setTimeout(init, 200);
        return;
      }

      const items = getItems(carousel);
      if (items.length < 2) {
        if (++tries < maxTries) return setTimeout(init, 200);
        return;
      }

      attachPauseListeners(section, carousel);

      // Only run when visible (stops background scrolling)
      io = new IntersectionObserver(
        (entries) => {
          const visible = entries?.[0]?.isIntersecting;
          if (!visible) {
            if (timer) clearInterval(timer);
            timer = null;
            return;
          }

          if (!timer) {
            timer = setInterval(() => {
              if (!isMobile() || REDUCE_MOTION.matches) return;
              if (Date.now() < pauseUntil) return;

              // Try native component method first; fallback to scrollIntoView
              const ok = tryNativeNext(carousel);
              if (!ok) fallbackScroll(carousel);
            }, INTERVAL_MS);
          }
        },
        { threshold: 0.35 }
      );

      io.observe(section);
    };

    init();
  }

  document.addEventListener("DOMContentLoaded", start);
  window.addEventListener("resize", start);
  MOBILE_MQ.addEventListener?.("change", start);
  REDUCE_MOTION.addEventListener?.("change", start);

  document.addEventListener("shopify:section:load", (e) => {
    if (e?.target?.id === SECTION_ID) start();
  });
  document.addEventListener("shopify:section:unload", (e) => {
    if (e?.target?.id === SECTION_ID) stop();
  });
})();


// Display daily price for subscription UI

(function () {
  const DAYS = 30;

  function textOf(el) {
    return (el && el.innerText ? el.innerText : '').replace(/\s+/g, ' ').trim();
  }

  function cleanOptionText(optionBox) {
    const clone = optionBox.cloneNode(true);

    // Remove custom per-day labels so they do not get re-read as prices.
    clone.querySelectorAll('.luminara-per-day').forEach(el => el.remove());

    // Remove custom yearly savings line so it does not get re-read as a price.
clone.querySelectorAll('.luminara-yearly-saving-line').forEach(el => el.remove());

    // Remove subscription description/tick list so "Save $21.00" is ignored.
    clone.querySelectorAll('.appstle_subscription_description_text').forEach(el => el.remove());

    return textOf(clone);
  }

  function getPrices(text) {
    /*
      Handles:
      $48.95
      A$70.84
      €43,36
      ¥8,063
      £39.95
      NZ$75.00
      S$65.00
      HK$380.00
    */
    return text.match(/(?:A\$|NZ\$|S\$|HK\$|US\$|\$|€|£|¥)\s?\d{1,3}(?:[,\s.]\d{3})*(?:[.,]\d{2})?|(?:A\$|NZ\$|S\$|HK\$|US\$|\$|€|£|¥)\s?\d+(?:[.,]\d{2})?/g) || [];
  }

  function parseMoney(priceText) {
    if (!priceText) return null;

    let cleaned = priceText.replace(/[^0-9.,]/g, '');

    if (!cleaned) return null;

    const hasComma = cleaned.includes(',');
    const hasDot = cleaned.includes('.');

    if (hasComma && hasDot) {
      const lastComma = cleaned.lastIndexOf(',');
      const lastDot = cleaned.lastIndexOf('.');

      if (lastComma > lastDot) {
        // European format: 1.234,56
        cleaned = cleaned.replace(/\./g, '').replace(',', '.');
      } else {
        // US/AU format: 1,234.56
        cleaned = cleaned.replace(/,/g, '');
      }
    } else if (hasComma && !hasDot) {
      const parts = cleaned.split(',');

      if (parts[parts.length - 1].length === 2) {
        // Decimal comma: 43,36
        cleaned = cleaned.replace(',', '.');
      } else {
        // Thousands comma / Yen format: 8,063
        cleaned = cleaned.replace(/,/g, '');
      }
    } else if (hasDot && !hasComma) {
      const parts = cleaned.split('.');

      if (parts.length > 2) {
        // Thousands dots: 1.234.567
        cleaned = cleaned.replace(/\./g, '');
      }
    }

    const amount = parseFloat(cleaned);
    return Number.isFinite(amount) ? amount : null;
  }

  function getCurrencyPrefix(priceText) {
    const match = priceText.match(/^(A\$|NZ\$|S\$|HK\$|US\$|\$|€|£|¥)/);
    return match ? match[1] : '$';
  }

  function currencyUsesDecimals(priceText) {
    const prefix = getCurrencyPrefix(priceText);

    // Yen usually displays without cents.
    if (prefix === '¥') return false;

    // If the displayed price has cents/decimals, keep cents in the per-day price.
    return /[.,]\d{2}$/.test(priceText.trim());
  }

  function makePerDayText(priceText) {
    const amount = parseMoney(priceText);
    if (!amount) return null;

    const prefix = getCurrencyPrefix(priceText);
    const decimals = currencyUsesDecimals(priceText) ? 2 : 0;

    return `${prefix}${(amount / DAYS).toFixed(decimals)} per day`;
  }

  function findOptionBox(labelText) {
    const boxes = Array.from(document.querySelectorAll('.appstle_subscription_wrapper_option'));

    return boxes.find(function (box) {
      return textOf(box).includes(labelText);
    }) || null;
  }

  function getActivePrice(optionBox, labelText) {
    let prices = getPrices(cleanOptionText(optionBox));

    if (!prices.length) return null;

    /*
      Subscribe & Save should usually have:
      1. SAVE badge amount
      2. Subscription price
      3. Compare-at price

      So we use the second price when available.
    */
    if (labelText === 'Subscribe & Save') {
      if (prices.length >= 3) {
        return prices[1];
      }

      if (prices.length >= 2) {
        return prices[1];
      }

      return prices[0] || null;
    }

    // Try Once should have one price.
    return prices[0] || null;
  }

  function addPerDay(labelText, className) {
    const optionBox = findOptionBox(labelText);
    if (!optionBox) return false;

    const activePrice = getActivePrice(optionBox, labelText);
    if (!activePrice) return false;

    const dailyText = makePerDayText(activePrice);
    if (!dailyText) return false;

    optionBox.classList.add('luminara-per-day-parent');

    let dailyEl = optionBox.querySelector('.' + className);

    if (!dailyEl) {
      dailyEl = document.createElement('div');
      dailyEl.className = 'luminara-per-day ' + className;
      optionBox.appendChild(dailyEl);
    }

    dailyEl.textContent = dailyText;
    return true;
  }

  function addMostPopularBadge() {
  const subBox = findOptionBox('Subscribe & Save');
  if (!subBox) return false;

  let badge = subBox.querySelector('.luminara-most-popular-badge');

  if (!badge) {
    badge = document.createElement('div');
    badge.className = 'luminara-most-popular-badge';
    badge.textContent = 'MOST POPULAR';
    subBox.appendChild(badge);
  }

  return true;
}

function updateSubscriptionSavingsText() {
  const subBox = findOptionBox('Subscribe & Save');
  const onceBox = findOptionBox('One-Time Purchase');

  if (!subBox || !onceBox) return false;

  const subPrice = getActivePrice(subBox, 'Subscribe & Save');
  const oncePrice = getActivePrice(onceBox, 'One-Time Purchase');

  if (!subPrice || !oncePrice) return false;

  const subAmount = parseMoney(subPrice);
  const onceAmount = parseMoney(oncePrice);

  if (!subAmount || !onceAmount || onceAmount <= subAmount) return false;

  const prefix = getCurrencyPrefix(oncePrice);
  const decimals = 0;
  const yearlySaving = (onceAmount - subAmount) * 12;

  let savingLine = subBox.querySelector('.luminara-yearly-saving-line');

  if (!savingLine) {
    savingLine = document.createElement('div');
    savingLine.className = 'luminara-yearly-saving-line';

    const title = subBox.querySelector('.appstle_subscription_wrapper_option_text') 
      || subBox.querySelector('.appstle_radio_label')
      || subBox;

    title.insertAdjacentElement('afterend', savingLine);
  }

  savingLine.textContent = `Save ${prefix}${yearlySaving.toFixed(decimals)} per year`;
  return true;
}

function updatePerDayLabels() {
  const subDone = addPerDay('Subscribe & Save', 'luminara-subscribe-per-day');
  const onceDone = addPerDay('One-Time Purchase', 'luminara-try-once-per-day');

  addMostPopularBadge();
  updateSubscriptionSavingsText();

  return subDone && onceDone;
}

  function start() {
    updatePerDayLabels();

    let attempts = 0;
    const checker = setInterval(function () {
      attempts += 1;

      const done = updatePerDayLabels();

      if (done || attempts >= 20) {
        clearInterval(checker);
      }
    }, 500);

    document.addEventListener('click', function () {
      setTimeout(updatePerDayLabels, 200);
      setTimeout(updatePerDayLabels, 800);
    });

    document.addEventListener('change', function () {
      setTimeout(updatePerDayLabels, 200);
      setTimeout(updatePerDayLabels, 800);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();


